// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1tbjn","buttons":"Footer_buttons__3gfpS"};